import styled from "@emotion/styled";
import { Variables } from "@repo/skapa";

import { FlexDiv } from "./FlexDiv";

export interface SectionContainerProps {
  row?: boolean;
  largeGap?: string;
}

// Handle layout style
export const SectionContainer = styled(FlexDiv)<SectionContainerProps>`
  gap: ${Variables.space75};
  flex-direction: ${(props) => (props.row ? "row" : "column")};
  ${(props) => (props.row ? "align-items: center" : "")};
  justify-content: start;

  @media (min-width: ${Variables.breakpointM}) {
    gap: ${(props) => (props.largeGap ? props.largeGap : Variables.space150)};
  }
`;
